<template>
  <div>
    <sea-page
      title="Cronologia di consegna e lettura documenti"
      header="Cronologia di consegna e lettura documenti"
      showCompanyHeader
      back
    >
      <sea-page-content
        :fetchList="fetchList"
        toolbar
        pulsanteAggiorna
        pulsanteStampaCronologia
        hideRapidSearch
        ref="history" 
        :items="items"

      >
        <template v-slot:table="{ attrs, height }">
          <v-data-table       
            v-model="attrs.selected"
            v-bind="attrs"
            :height="height"
            :headers="headers"
            :items="filteredItems"
            dense
            show-select
            sort-by="data"
            @update:sort-by="sortBy"
            @click:row="rowClick"
          >
          <template v-slot:header.data-table-select="{ props, on }">
          <div class="d-flex flex-row">
            <v-simple-checkbox
              v-bind="props"
              v-on="on"
              :ripple="false"
            ></v-simple-checkbox>
            <v-menu offset-y :close-on-content-click="false">
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on"> mdi-menu-down </v-icon>
              </template>
              <v-list>
                <v-list-item>
                  <v-list-item-action>
                    <v-checkbox
                      @click="$refs.history.addRemoveAllHistory()"
                      v-model="attrs.allFilters"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>Tutti</v-list-item-title>
                </v-list-item>
                <v-list-item
                  v-for="(status, index) in attrs.filters"
                  :key="index"
                >
                  <v-list-item-action>
                    <v-checkbox
                      @click="$refs.history.addRemoveStatusHistory(status.value)"
                      v-model="status.active"
                    ></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-title>{{ status.text }}</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
          </v-data-table>
          
        </template>
      </sea-page-content>
    </sea-page>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";


const headers = [
  {
    text: "Data",
    value: "data",
    class: ["heading", "sort"],
    cellClass: "text-little-2",
  },
  {
    text: "Ora",
    value: "ora",
    class: ["heading"],
    cellClass: "text-little-2",
  },
  {
    text: "Utente",
    value: "utente",
    class: ["heading"],
    cellClass: "text-little-2",
  },
  {
    text: "Cognome e nome",
    value: "cognomeNome",
    class: ["heading"],
    cellClass: "text-little-2",
  },
  {
    text: "Tipo",
    value: "tipoUtente",
    class: ["heading"],
    cellClass: "text-little-2",
  },
  {
    text: "Documento",
    value: "documento",
    class: "heading",    
    sortable: false,
    filterable: false,
    cellClass: "text-little-2",
  },
  {
    text: "Stato",
    value: "stato",
    class: "heading",
    sortable: false,
    filterable: false,
    cellClass: "text-little-2",
  },
  {
    text: "Note",
    value: "note",
    class: "heading",
    sortable: false,
    filterable: false,
    cellClass: "text-little-2",
  },
];

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.setCurrentDocId(to.params.id);
      if(to.query.listaID) {
        vm.setcurrentListDocId(to.query.listaID);
      }
      
    });
  },
  data() {
    return {
      headers,
    };
  },
  mounted() {
  },

  methods: {
    ...mapActions({
      setCurrentDocId: "proxy/setCurrentDocId",
      fetchList: "proxy/fetchListHistory",
      setcurrentListDocId: "proxy/setcurrentListDocId",

    }),
    sortBy(val) {
      this.headers.forEach((h) => {
        h.class = ["text-little-2"];
        if (h.value === val) h.class.push("sort");
      });
    },
    rowClick: function (_, row) {
      row.select(!row.isSelected);
    },

  },
  computed: {
    ...mapGetters({
      items: "proxy/history",
    }),
    filteredItems(){
      let out = [...this.items];
      return out;
    }
  },
};
</script>

<style>
</style>